import { render, staticRenderFns } from "./package-details.vue?vue&type=template&id=59764b00&scoped=true"
import script from "./package-details.vue?vue&type=script&setup=true&lang=js"
export * from "./package-details.vue?vue&type=script&setup=true&lang=js"
import style0 from "./package-details.vue?vue&type=style&index=0&id=59764b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59764b00",
  null
  
)

export default component.exports